import { applyMiddleware, compose, createStore as createReduxStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { createRootReducer } from './createRootReducer.js';
import createMainSaga from './createMainSaga.js';
import { actionSanitizer } from './actionSanitizer.js';

import _d from '@repperjs/debug';
import { actionsDenylist } from './actionsDenylist.js';

/* eslint-disable no-unused-vars */
const log = _d('repper:store:createStore'),
    error = _d('repper:error'),
    warn = _d('repper:warning');
/* eslint-enable no-unused-vars */

export const createStore = (initialState = {}, history, routes) => {
    // ======================================================
    // Middleware Configuration
    // ======================================================
    // set up redux-saga
    const sagaMiddleware = createSagaMiddleware({
        onError: (e, { sagaStack }) => {
            error('Error occurred in saga middleware', e, sagaStack);
            // unmount whole react three
            if ('handleError' in window) {
                window.handleError({ error: e, source: 'sagaErrorHandler', errorInfo: { sagaStack } });
            }
        },
    });

    const middleware = [sagaMiddleware]; // for dispatching history actions];

    // ======================================================
    // Store Enhancers
    // ======================================================
    const enhancers = [];

    let composeEnhancers = compose;

    const composeWithDevToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    if (typeof composeWithDevToolsExtension === 'function') {
        // make sure that large actions aren't using up lots of CPU / memory

        composeEnhancers = composeWithDevToolsExtension({
            actionSanitizer,
            actionsDenylist,
        });
    }

    // ======================================================
    // Store Instantiation and HMR Setup
    // ======================================================
    const store = createReduxStore(
        createRootReducer(history, routes),
        initialState,
        composeEnhancers(applyMiddleware(...middleware), ...enhancers),
    );

    sagaMiddleware.run(createMainSaga(routes));

    return store;
};
